import i18n from 'config/i18n';
import { Dayjs } from 'dayjs';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      dutyCodePeriodId: yup.number().nullable().optional(),
      dutyHourTypeId: yup
        .number()
        .min(1, t('validationFieldRequired', { name: t('dutyHourType') })),
      startTime: yup
        .mixed<Dayjs>()
        .required(t('validationFieldRequired', { name: t('startTime') })),
      endTime: yup
        .mixed<Dayjs>()
        .required(t('validationFieldRequired', { name: t('endTime') }))
    })
    .required();
};

export default getSchema;
